// Generated by CoffeeScript 2.7.0
var Admin__Settings__WechatAuthorizedController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsWechatAuthorized from 'trunks/vue/admin/components/settings/settings_container/settings_wechat_authorized.js';

export default Admin__Settings__WechatAuthorizedController = (function() {
  class Admin__Settings__WechatAuthorizedController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return new SettingsWechatAuthorized({
        el: DomMaster.find("#js-settings-wechat_authorized").node,
        propsData: {
          activeTab: 'wechat_authorized',
          authorized: this.getVars('authorized'),
          authorityIds: this.getVars('authority_ids'),
          authorizeUrl: this.getVars('authorize_url'),
          wechatAccessList: this.getVars('wechat_access_list')
        }
      });
    }

  };

  Admin__Settings__WechatAuthorizedController.include(GenerateMorePopover);

  Admin__Settings__WechatAuthorizedController.include(SettingsNavigator);

  return Admin__Settings__WechatAuthorizedController;

}).call(this);
